import axios from 'axios';
import {backendHost} from '../../config';

export const getOffers = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/offer`, {params});
};